import { handleApiError } from '@api';
import config from '@config';
import { HTTPClient } from '@platform2-lib/httpz';
import * as schema from '@schema';
import type {
  Insight,
  InsightChart,
  SourcesOverviewResponse
} from 'types/schema';

const client = new HTTPClient(
  config.env,
  `${config.api.origin}/spark-agent-v2`
);

async function getChartData(insightId: Insight['id']): Promise<InsightChart> {
  try {
    const response = await client.get(
      `/sources/insights/${insightId}`,
      schema.InsightChart
    );

    return response;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve visualization data.', true);
  }
}

async function getOverviewData(
  replyId: string
): Promise<SourcesOverviewResponse> {
  try {
    const response = await client.get(
      `/sources/overview/${replyId}`,
      schema.SourcesOverviewResponse
    );
    return response;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve overview data.');
  }
}

async function getSummary(replyId: string): Promise<string> {
  try {
    const { summary } = await client.get(
      `/sources/summary/${replyId}`,
      schema.SourcesSummaryResponse
    );
    return summary;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve summary data.');
  }
}

export const sources = {
  getChartData,
  getOverviewData,
  getSummary
};
